import { useRef, useState } from 'react';
import { Drawer, Button } from '@navi/web-ui/lib/primitives';
import { AgentForm } from '../../AgentForm';
import { AddFormDrawerProps } from '../../interfaces/types';
import { VERIFICATION_STATUS } from '../../constants/constants';

const AddFormDrawer = (props: AddFormDrawerProps) => {
  const { isDrawerOpen, onClose, showLoader, setShowLoader } = props;
  const agentFormRef = useRef<any>(null);
  const handleSubmitClick = () => {
    if (agentFormRef.current) {
      agentFormRef.current.submitForm();
    }
  };

  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(false);
  const [showActionButton, setShowActionButton] = useState(false);
  const [locationVerificationStatus, setLocationVerificationStatus] = useState(
    VERIFICATION_STATUS.UNVERIFIED
  );
  const [showLocationVerificationToast, setShowLocationVerificationToast] = useState(false);

  return (
    <Drawer
      open={isDrawerOpen}
      onClose={onClose}
      headerText="Add User"
      showHeaderDivider={true}
      usePadding={false}
      contentClasses="overflow-auto"
      style={{ width: '400px' }}
      footer={
        showActionButton ? (
          <div>
            <Button
              variant="primary"
              fullWidth
              type="submit"
              onClick={handleSubmitClick}
              disabled={isSubmitButtonDisabled}
            >
              Add User
            </Button>
          </div>
        ) : (
          <></>
        )
      }
    >
      <div>
        <section>
          {isDrawerOpen ? (
            <AgentForm
              ref={agentFormRef}
              onClose={onClose}
              isDrawerOpen={isDrawerOpen}
              setIsSubmitButtonDisabled={setIsSubmitButtonDisabled}
              showLoader={showLoader}
              setShowLoader={setShowLoader}
              setShowActionButton={setShowActionButton}
              showLocationVerificationToast={showLocationVerificationToast}
              setShowLocationVerificationToast={setShowLocationVerificationToast}
              locationVerificationStatus={locationVerificationStatus}
              setLocationVerificationStatus={setLocationVerificationStatus}
            />
          ) : null}
        </section>
      </div>
    </Drawer>
  );
};

export default AddFormDrawer;
